module.exports = __webpack_public_path__ + "static/media/pack1.a325b611.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pack1.jpg
// module id = 885
// module chunks = 0